import { useState } from "react";

const FAQS = [
  {
    q: "什么是吃瓜八卦考古？",
    a: "吃瓜八卦考古指的是把过去某段时间里被热议、却逐渐被遗忘的娱乐八卦事件重新翻出来，梳理事件起因、经过和后续，用时间线的方式呈现给吃瓜群众，俗称翻旧账、挖旧料、陈年旧料考古。",
  },
  {
    q: "吃瓜八卦考古的内容从哪来？",
    a: "我们以公开的新闻报道、采访记录和网络公开资料为基础，按时间顺序交叉比对不同来源，尽量还原事件原貌，并标注时间节点与来源，减少以讹传讹。",
  },
  {
    q: "网站更新吃瓜八卦旧料的频率是多久？",
    a: "吃瓜考古社会结合热点与时令不定期更新，每当旧话题再次被提起或迎来周年节点，就会推送一批对应的陈年往事与时间线整理。",
  },
  {
    q: "翻旧账的时间线是怎么整理的？",
    a: "我们会先把同一个事件散落在不同年份的线索抽出来，按年、月、日排序，再补充事件爆发前后双方的动作与舆论反应，最终形成一条清晰可读的吃瓜八卦时间线。",
  },
  {
    q: "我也可以参与吃瓜八卦考古投稿吗？",
    a: "当然可以。如果你手上有值得回味的旧料线索，欢迎在下方订阅与联系表单里告诉我们，编辑部会核对时间线并补充细节后整理归档。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.5fr]">
          <div className="flex flex-col gap-2 border-l-4 border-primary-500 pl-4">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-secondary-600">常见问题 · FAQ</p>
            <h2 className="font-heading text-3xl font-black text-foreground-950 md:text-4xl">关于翻旧账，你可能想问</h2>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              关于吃瓜八卦考古的方法、来源与更新节奏，这里一并说清楚。
            </p>
          </div>

          <div className="space-y-3">
            {FAQS.map((f, i) => {
              const active = open === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    active ? "border-accent-300 bg-background-50" : "border-background-300/60 bg-background-50"
                  }`}
                >
                  <button
                    onClick={() => setOpen(active ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    aria-expanded={active}
                  >
                    <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{f.q}</h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        active ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={`${active ? "ri-subtract-line" : "ri-add-line"} text-lg`} />
                    </span>
                  </button>
                  {active && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700 md:text-[15px]">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}